<template>
  <div class="password-resets-container">
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h1 class="text-md-center earth-color">PASSWORD RESETS</h1>
        <div class="title-decoration"></div>
      </div>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          placeholder="Search password resets..."
          single-line
          hide-details
          v-model="search"
          class="futuristic-input"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="passwordResetsColumns"
        :items="passwordResetsLogs"
        :search="search"
        :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear
          slot="progress"
          color="#587e27"
          indeterminate
          height="3"
        ></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>{{ formated_date_time(props.item.created_at) }}</td>
          <td class="font-weight-medium">{{ props.item.email }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>

      <v-container class="action-buttons">
        <v-btn
          depressed
          @click="getMore()"
          color="#2196f3"
          :loading="this.$store.state.LoadingStore.loading"
          class="futuristic-btn"
        >
          <v-icon left>add</v-icon>
          GET MORE
        </v-btn>
        <v-btn
          depressed
          @click="getAllPasswordResetLogs()"
          color="#9e9e9e"
          :loading="this.$store.state.LoadingStore.loading"
          class="futuristic-btn"
        >
          <v-icon left>list</v-icon>
          GET ALL
        </v-btn>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "PasswordResetLogs",
  data() {
    return {
      search: "",
      page: 2,
      passwordResetsColumns: [
        {
          text: "Done at",
          value: "created_at",
          class: "table-header"
        },
        {
          text: "Email",
          value: "email",
          class: "table-header"
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("get_password_reset_logs");
  },
  methods: {
    getMore() {
      this.loading = true;

      if (this.page === 2) {
        this.$store.dispatch("get_more_password_reset_logs", this.page);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_more_password_reset_logs", this.page);
        this.page = this.page + 1;
      }
    },
    getAllPasswordResetLogs() {
      this.loading = true;
      this.page = 0;
      this.$store.dispatch("get_more_password_reset_logs", this.page);
    },
  },
};
</script>

<style scoped>
.password-resets-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.password-resets-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-buttons {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 0 0 8px 8px;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .password-resets-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }

  .action-buttons {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .password-resets-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
}
</style>